/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "antd/dist/reset.css";
import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";
import moment from "moment";
import "moment/locale/es";
import "./index.css";
import "leaflet/dist/leaflet.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


moment.locale("es");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={esES}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// Registrar el service worker para hacer la app instalable
serviceWorkerRegistration.register();

